<script setup lang="ts">
  import type { TypographyProps } from '../Typography/Typography.vue'

  const { t } = useI18n()
  export type ArticleHeaderProps = {
    title: string
    publisherIconUrl?: string
    publisherName?: string
    publishedDate: string
    category: string
    design?: 'msn' | 'google' | null
    type?: 'video'
    source?: string
  }

  const props = withDefaults(defineProps<ArticleHeaderProps>(), {
    design: 'google',
    type: undefined,
    publisherIconUrl: '',
    publisherName: '',
    source: '',
  })

  const parsedDate = computed(() =>
    useExpandedPublishedDate(props.publishedDate)
  )

  const titleProps = computed<TypographyProps>(() => {
    if (props.design === 'msn') {
      return {
        variant: 'text-[24px]',
        element: 'h1',
        weight: 'font-semibold',
        class: 'leading-8',
        color: 'text-content-primary',
      }
    }
    return {
      variant: 'text-[40px]',
      element: 'h1',
      weight: 'font-normal',
      class: 'leading-13',
      color: 'text-content-primary',
    }
  })
</script>
<template>
  <div
    :class="[
      {
        'flex flex-col gap-6 pb-8': design === 'google',
        'flex flex-col gap-8px pb-6 border-b border-background-neutral-muted':
          design === 'msn',
      },
    ]"
  >
    <Typography v-bind="titleProps" class="line-clamp-3">
      {{ props.title }}
    </Typography>
    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
      <div class="flex flex-row items-center gap-3">
        <Typography
          v-if="type !== 'video' && source !== 'canadian_press'"
          variant="text-sm"
          color="text-content-secondary"
        >
          {{ t('Original Story by') }}
        </Typography>
        <div v-if="type !== 'video'" class="flex flex-row items-center gap-2">
          <NuxtImg
            v-if="type !== 'video'"
            :src="props.publisherIconUrl"
            class="h-[16px] w-[16px] rounded-full"
          />
          <Typography
            v-if="type !== 'video'"
            variant="text-sm"
            color="text-content-secondary"
          >
            {{ props.publisherName }}
          </Typography>
        </div>
      </div>
      <Typography
        v-if="type !== 'video'"
        variant="text-sm"
        color="text-content-secondary"
        classes="hidden sm:block"
      >
        ·
      </Typography>
      <div class="flex flex-row items-center gap-4">
        <Typography variant="text-sm" color="text-content-secondary">
          {{ parsedDate }}
        </Typography>
        <Typography variant="text-sm" color="text-content-secondary">
          ·
        </Typography>
        <Typography variant="text-sm" color="text-content-secondary">
          {{ t(props.category) }}
        </Typography>
      </div>
    </div>
  </div>
</template>
